import { HiverAxios } from 'h-commons';
import {
    GET_BILL_AMOUNT_DONE,
    GET_BILL_AMOUNT_FAILED,
    GET_BILL_AMOUNT_INIT
} from './types';
export const getAmountToBill = (userId, planId, isChargeBeeEnabled) => (dispatch) => {
    dispatch({ type: GET_BILL_AMOUNT_INIT });
    let url = ( isChargeBeeEnabled ) ? '/api/payment/previewPlan?' : `/stripe/getAmountToBill_ExistingorNewCustomer?`;
    url += `usersession=${userId}&plan_id=${planId}`;
    return new Promise((res, rej) => {
        HiverAxios({
            url,
            type: 'GET',
            callback: resp => {
                if (resp.data){ 
                    const allData = {...resp.data, billPlanId:planId}
                    dispatch({
                        type: GET_BILL_AMOUNT_DONE,
                        payload: allData
                    });
                    res(allData);
                }
                else{
                    dispatch({
                        type: GET_BILL_AMOUNT_FAILED
                    });
                    rej('')
                }
            }, 
            onfail: () => {
                    dispatch({
                        type: GET_BILL_AMOUNT_FAILED
                    })
                    rej('')
            }
        });
    })
}